import { useMemo } from 'react'
import type { ActionModuleInstanceModel } from '@/api/model'
import { useGetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances } from '@/api/generated/company-management-user/company-management-user'
import { toIso } from '@/pages/incentivation/lib'
import type { IncentivationFilterValues } from './IncentivationFilters'

/**
 * Loads an employee's instances over the applied range. Centralised so every consumer
 * (the instance column, chart, details and the tab's cross-employee instance matching)
 * issues the *same* query key and shares React Query's cache — one fetch feeds all of
 * them. Pass `enabled: false` to hold the query until an employee is actually selected.
 */
export function useInstances(
  moduleId: number,
  employeeId: string,
  applied: IncentivationFilterValues,
  options?: { enabled?: boolean },
) {
  const query = useGetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances(
    moduleId,
    employeeId,
    {
      startDate: toIso(applied.start),
      endDate: toIso(applied.end, true),
    },
    { query: { enabled: (options?.enabled ?? true) && !!employeeId } },
  )

  const instances = useMemo<ActionModuleInstanceModel[]>(() => {
    const raw = (query.data as any)?.data ?? query.data
    return Array.isArray(raw) ? raw : []
  }, [query.data])

  return { ...query, instances }
}
